import { render, staticRenderFns } from "./SchoolPlan.vue?vue&type=template&id=4770c492&scoped=true"
import script from "./SchoolPlan.vue?vue&type=script&lang=js"
export * from "./SchoolPlan.vue?vue&type=script&lang=js"
import style0 from "./SchoolPlan.vue?vue&type=style&index=0&id=4770c492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4770c492",
  null
  
)

export default component.exports